import React, { memo } from 'react'
import AbsenceRequestProvider from 'redesign/services/absence-request/absence-request-provider'
import NewAbsenceRequestAlertContent from './new-absence-request-alert-content'
import type { NewAbsenceRequestEventAlertProps } from './types'

const NewAbsenceRequestAlert: React.FC<NewAbsenceRequestEventAlertProps> = (props) => (
  <AbsenceRequestProvider>
    <NewAbsenceRequestAlertContent {...props} />
  </AbsenceRequestProvider>
)

export default memo(NewAbsenceRequestAlert)
